<script>
  import { _ } from "svelte-i18n"

  // import { toggleFullScreen } from "../js/functions"
</script>

<div class="choose">
  <h3>{$_("chooseClassTitle")}</h3>

  <div>
    <div class="box">
      <h4>{$_("addition")}</h4>
      <div class="taxeis">
        <a href="./?class=a">{$_("classA")}</a>
        <a href="./?class=b">{$_("classB")}</a>
        <a href="./?class=c">{$_("classC")}</a>
      </div>
    </div>
  </div>
  <div>
    <div class="box">
      <h4>{$_("multiplication")}</h4>
      <div class="taxeis">
        <a href="./?class=b&praxi=propaideia">{$_("classB")}</a>
        <a href="./?class=c&praxi=propaideia">{$_("classC")}</a>
      </div>
    </div>
  </div>
</div>

<style>
  .choose {
    margin-top: -160px;
    font-size: 1.8rem;
    color: white;
    background: rgba(0, 0, 0, 0.6);
    padding: 30px 40px;
    border-radius: 20px;
    height: fit-content;
    display: flex;
    flex-direction: column;
    gap: 40px;
  }

  .box {
    border: 1px solid rgb(255, 255, 255, 0.2);
    border-radius: 20px;
    padding: 10px;
  }

  .taxeis {
    display: flex;
    justify-content: center;
    /* margin-top: 40px; */
  }

  h3,
  h4 {
    text-align: center;
  }

  a {
    text-decoration: none;
    padding: 9px 16px;
    margin: 10px;
    /* opacity: 0.85; */
    /* font-size: 42px; */
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 50;
    position: relative;
    cursor: pointer;
    color: white;

    box-shadow: 0 20px 30px rgba(0, 0, 0, 0.2),
      inset 0px 30px 50px 5px rgb(61, 223, 223);
  }

  a:hover {
    box-shadow: 0 0 30px #fff, inset 0px 30px 50px 5px rgb(61, 223, 223);
  }

  @media (max-width: 600px) {
    .choose {
      font-size: 1.3rem;
      padding: 25px;
      gap: 10px;
      margin-top: -160px;
      /* margin: 10px 20px; */
    }

    a {
      padding: 6px;
      margin: 6px;
    }

    .taxeis {
      flex-direction: column;
      /* margin-top: 20px; */
    }
  }

  /* @media (max-width: 400px) {
    .choose {
      font-size: 1rem;
      padding: 25px;
      gap: 10px;
      margin-top: -160px;
    }

    a {
      padding: 6px;
      margin: 6px;
    }

    .taxeis {
      flex-direction: column;
    }
  } */

  @media (max-height: 700px) {
    .choose {
      font-size: 1rem;
      padding: 25px;
      gap: 10px;
      margin-top: -160px;
    }

    a {
      padding: 6px;
      margin: 6px;
    }

    .taxeis {
      flex-direction: column;
    }
  }
</style>
